module.exports = __webpack_public_path__ + "img/noobizes.d3386925.png";